import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[appLogo]'
})
export class LogoDirective {
  siteProperties: any;
  baseUrl: string;
  themeList: any;
  logoMarkup: string;
  logo: string;
  ApiKey: string;

  constructor(public el: ElementRef, public renderer: Renderer2, private themeService: ThemeService) {
    themeService.getBaseUrl().once('value', snapshot => {
      this.siteProperties = [];
      this.ApiKey = localStorage.getItem('APIKey');
      snapshot.forEach(snap => {
        if (snap.val().state === '1') {
          this.siteProperties.push({
            baseUrl: snap.val().base_url
          });
        }
      });
      this.baseUrl = this.siteProperties[0].baseUrl;
    });

    this.themeService.getThemeList().once('value', snapshot => {
      this.themeList = [];
      if (localStorage.getItem('logo')) {
        this.logo = localStorage.getItem('logo') + '?api+key=' + this.ApiKey;
      } else {
        snapshot.forEach(snap => {
          if (snap.val().state === '1') {
            this.themeList.push({
              logo: this.baseUrl + '/' + snap.val().logo + '?api+key=' + this.ApiKey
            });
          }
        });
        this.logo = this.themeList[0].logo;
      }
      const img = this.renderer.createElement('img');
      this.renderer.setAttribute(img, 'src', this.logo);
      this.renderer.setStyle(el.nativeElement, 'display', 'block');
      this.renderer.setStyle(el.nativeElement, 'text-align', 'center');
      this.renderer.setStyle(el.nativeElement, 'margin', '0 auto');
      this.renderer.setStyle(el.nativeElement, 'max-width', '50%');
      this.renderer.appendChild(el.nativeElement, img);
    });
  }

}
